import { Button, Stack, Typography } from '@mui/material'
import { RosterStatus } from '__generated__/graphql'
import RosterFilters from 'client/shared/RosterFilters'
import { useState } from 'react'
import { LoadingPanel } from 'shared/components/LoadingPanel'
import { GroupedStatus, RosterResults } from 'shared/models/groupedStatus'
import { getPxAsRem } from 'shared/utils'

export interface RosterByStatusListProps {
    pageTitle?: string
    statuses: GroupedStatus[]
    getPaginationForFilter: (status: GroupedStatus) => {
        loading: boolean
        data: RosterResults
        isFetching: boolean
        refetch: () => void
        trackedDivClassName: string
    }
    saveFilterKey: string
    children: (data: RosterResults[number]) => React.ReactNode
    addButton?: {
        onClick: () => void
        label: string
    }
}

const RostersByStatusList: React.FC<RosterByStatusListProps> = ({
    pageTitle,
    statuses,
    getPaginationForFilter,
    saveFilterKey,
    children,
    addButton,
}) => {
    const [activeFilter, setActiveFilter] = useState<GroupedStatus>(() => {
        const urlParams = new URLSearchParams(window.location.search)
        const activeTabParam = urlParams.get(saveFilterKey) as RosterStatus
        return (
            statuses.find((status) => status.status === activeTabParam) ??
            statuses[0]
        )
    })
    const { loading, data, isFetching, trackedDivClassName } =
        getPaginationForFilter(activeFilter)

    return (
        <>
            {statuses.length > 0 && (
                <Stack
                    display={'flex'}
                    width={'100%'}
                    minWidth={getPxAsRem(375)}
                    padding={getPxAsRem(24, 24)}
                    gap={getPxAsRem(3, 24)}
                    spacing={3}
                    direction="column"
                    alignItems={'flex-start'}
                >
                    <Typography variant="h2">{pageTitle ?? ''}</Typography>

                    <Stack
                        direction={'row'}
                        width={'100%'}
                        justifyContent={'space-between'}
                    >
                        <RosterFilters
                            onStatusClick={(status: GroupedStatus) => {
                                setActiveFilter(status)
                            }}
                            statuses={statuses}
                            saveFilterKey={saveFilterKey}
                            initialFilter={activeFilter}
                        />
                        {addButton && (
                            <Button
                                variant="contained"
                                onClick={addButton.onClick}
                            >
                                <Typography variant="button">
                                    {addButton.label}
                                </Typography>
                            </Button>
                        )}
                    </Stack>
                    <Stack
                        display={'flex'}
                        width={'100%'}
                        direction="column"
                        spacing={3}
                    >
                        {loading ? (
                            <LoadingPanel />
                        ) : data?.length ? (
                            data?.map((roster, index) => {
                                return (
                                    <div
                                        className={`${trackedDivClassName}`}
                                        key={`${roster?.id}-${index}`}
                                    >
                                        {children({
                                            ...roster,
                                        })}
                                    </div>
                                )
                            })
                        ) : (
                            <Typography variant="h3" textAlign={'center'}>
                                No Results Found
                            </Typography>
                        )}
                        {isFetching && <LoadingPanel />}
                    </Stack>
                </Stack>
            )}
        </>
    )
}
export default RostersByStatusList
